<template>
  <div>
    <v-card outlined :color="chatIsEdit ? 'light-blue lighten-5' : ''">
      <v-card-text>
        <div v-if="chatIsEdit && selectedChatForEdit">
          <div class="mb-3">
            <b>{{ selectedChatForEdit.userFullName }}</b>
            <span class="mr-2">{{
              selectedChatForEdit.createdTimeUtc | moment
            }}</span>
            <small v-if="selectedChatForEdit.edited">(ویرایش شده)</small>
          </div>
        </div>
        <v-form ref="chatForm" v-model="chatValid">
          <v-row>
            <v-col cols="12">
              <v-textarea
                label="متن پیام"
                outlined
                dense
                required
                :rules="[
                  (v) => {
                    if(!v){
                      return 'وارد کردن متن پیام الزامی میباشد'
                    }
                    if (v && (v.length > 4096 || v.length <8 ) ){
                        return 'تعداد کاراکتر ها باید بین 8 تا 4096 عدد باشد';
                      }
                    
                    else return true;
                    }
                ]"
                v-model="chat.message"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <new-files-uploader
                :files="attachments"
                ref="filesUploder"
              ></new-files-uploader>
            </v-col>
          </v-row>
        </v-form>
        <div
          class="mt-3"
          v-if="selectedChatForEdit && selectedChatForEdit.isRead && chatIsEdit"
        >
          <span>خوانده شده</span>
          <span class="mr-2">{{
            selectedChatForEdit.readTimeUtc | moment
          }}</span>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="error" small @click="closeForm()">  انصراف </v-btn>
        <v-btn color="primary" small @click="sendMessage()">
          {{ chatIsEdit ? 'ویرایش پیام' : 'ارسال پیام ' }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import NewFilesUploader from '@/components/core/NewFilesUploader';
import Helper from '@/core/helpers';
const tradeRequestChatWithAdminRepository = () =>
  RepoFactory.get('tradeRequestChatWithAdmin');
import { RepoFactory } from '@/baseRepository/Factory';
export default {
  props: {
    chatIsEdit: {
      type: Boolean,
      default: false,
    },
    selectedChatForEdit: {
      type: Object,
      default: null,
    },
  },
  components: {
    NewFilesUploader,
  },
  data() {
    return {
      chatValid: true,
      chat: {
        message: null,
        tradeRequestId: null,
        attachments: [],
      },
      attachments: [],
    };
  },
  computed: {
    baseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    id() {
      return this.$route.params.id;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  created() {
    if (this.chatIsEdit && this.selectedChatForEdit) {
      this.fillInput();
    }
  },
  watch: {
    chatIsEdit(after, before) {
      if (after && this.selectedChatForEdit) {
        this.fillInput();
      }
    },
  },
  methods: {
    fillInput() {
      this.chat = {
        message: this.selectedChatForEdit.message,
        attachments: [],
      };
      this.attachments = this.selectedChatForEdit.attachments;
      if (
        this.selectedChatForEdit.attachments &&
        this.selectedChatForEdit.attachments.length
      ) {
        this.selectedChatForEdit.attachments.forEach((element) => {
          this.chat.attachments.push(element.fileId);
          console.log(this.chat.attachments);
        });
      }
    },
    closeForm() {
      this.$emit('closeChatForm');
    },
    sendMessage() {
      if (this.$refs.chatForm.validate()) {
        if (
          this.$refs.filesUploder.uploadedFilesId &&
          this.$refs.filesUploder.uploadedFilesId.length
        ) {
          this.chat.attachments = this.$refs.filesUploder.uploadedFilesId;
        }
        if (!this.chatIsEdit) {
          this.createMessage();
        } else {
          this.editMessage();
        }
      } else {
        this.$dialog.error({
          text: 'وارد کردن متن پیام الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    createMessage() {
      const loader = this.$loading.show();
      this.chat.tradeRequestId = this.id;
      tradeRequestChatWithAdminRepository()
        .addTradeRequestChatsWithAdmin(this.chat, this.baseUrl)
        .then((data) => {
          this.closeForm();
          this.$dialog.message.success('با موفقیت ثبت گردید', {
            position: 'top-left',
          });
          this.$emit('getTradeRequestChatsWithAdmin');
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    editMessage() {
      const loader = this.$loading.show();
      tradeRequestChatWithAdminRepository()
        .editTradeRequestChatsWithAdmin(
          this.selectedChatForEdit.id,
          this.chat,
          this.baseUrl
        )
        .then((data) => {
          this.closeForm();
          this.$dialog.message.success('با موفقیت ثبت گردید', {
            position: 'top-left',
          });
          this.$emit('getTradeRequestChatsWithAdmin');
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style></style>
